module.exports = __webpack_public_path__ + "img/icon_map.62202a34.png";